module.exports = __webpack_public_path__ + "static/img/273_TO8_2391_og.fc42e16.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/273_TO8_2391_og.jpg
// module id = rwVn
// module chunks = 0